import { Form, Nav } from "react-bootstrap";
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileLines, faLineChart, faUsers, faUser, faVial, faCar, faCity, faArrowsTurnToDots, faMagnifyingGlassDollar, faGear, faLandmark, faHandshake, faGavel, faAngleDoubleLeft, faAngleDoubleRight, faUserShield } from '@fortawesome/free-solid-svg-icons';
import { useDataStore } from '../Store'

const Sidebar = ({ entityChanged, dealerChanged, isOpen, toggleOpenClosed }) => {

    const selectedDealer = useDataStore((state) => state.selectedDealer);
    const selectedEntity = useDataStore((state) => state.selectedEntity);
    const user = useDataStore((state) => state.user);

    const iconMap = { faLineChart, faFileLines, faUsers, faUser, faVial, faCar, faCity, faArrowsTurnToDots, faMagnifyingGlassDollar, faGear, faLandmark, faHandshake, faGavel, faUserShield };
    const businessPartners = user?.Entities?.find(c => c.Id == selectedEntity)?.BusinessPartners || [];

    return (
        <Nav className="d-block d-md-block bg-light sidebar bg-light p-0"
            style={{ height: '100%' }}
            activeKey="/"
            onSelect={selectedKey => alert(`selected ${selectedKey}`)} >
            <div className="d-flex flex-column" style={{ paddingTop: 12, paddingRight: 12, paddingLeft: 12 }}>
                <span style={{ textAlign: 'right', width: '100%', cursor:'pointer' }} onClick={toggleOpenClosed}>
                    <FontAwesomeIcon icon={isOpen ? faAngleDoubleLeft : faAngleDoubleRight} style={{ fontSize: '16px', padding: 3, border: '1px solid black' }} />
                </span>
                {isOpen && (
                    <>
                        <span style={{ textAlign: 'center', width: '100%' }}>Servicing</span>
                        <Form.Control
                            style={{ fontSize: 12, cursor:'pointer' }}
                            as="select"
                            onChange={entityChanged}
                            value={selectedEntity}>
                            <option value="">Select a Entity</option>
                            {user?.Entities?.map((d, index) => (
                                <option key={d.Id} value={d.Id}>
                                    {d.Name}
                                </option>
                            ))}
                        </Form.Control>
                        <Form.Label className="mb-3" style={{ fontSize: 10 }} htmlFor="leaseVin"><span style={{ color: 'red' }}>*</span>Entity</Form.Label>
                        <Form.Control
                            style={{ fontSize: 12, cursor:'pointer' }}
                            as="select"
                            onChange={dealerChanged}
                            value={selectedDealer}>
                            <option value="">Select a Dealer</option>
                            {businessPartners?.map((d, index) => (
                                <option key={d.Id} value={d.Id}>
                                    {d.Name}
                                </option>
                            ))}
                        </Form.Control>
                        <Form.Label className="mb-2" style={{ fontSize: 10 }} htmlFor="leaseVin"><span style={{ color: 'red' }}>*</span>Dealer</Form.Label>
                    </>
                )}
            </div>
            <hr />
            {user?.NavItems.map((navItem, i) => (
                <Nav.Item key={i}>
                    <Nav.Link as={NavLink} to={navItem?.Route} className="d-flex align-items-center">
                        <span className="icon-wrapper me-2">
                            <FontAwesomeIcon icon={iconMap[navItem?.FaIcon]} style={{ fontSize: '16px' }} />
                        </span>
                        {isOpen && navItem?.Text}
                    </Nav.Link>
                </Nav.Item>
            ))}
        </Nav>
    );
};

export default Sidebar;
